import React from "react"
import SchwierigkeitsgradFull from "../images/schwierigkeitsgrad-full.svg"
import SchwierigkeitsgradHalf from "../images/schwierigkeitsgrad-half.svg"

const Schwierigkeitsgrad = (props) => {
  const fullBears = Math.floor(props.schwierigkeit.schwierigkeit)
  const rest = props.schwierigkeit.schwierigkeit % 1
  var fullBearsArray = []
  for (var i = 0; i < fullBears; i++) {
    fullBearsArray.push(<img alt="" src={SchwierigkeitsgradFull}></img>)
  }
  const fullBearsHtml = (
    <div>
      <div className="schwierigkeitsgrad">
        {fullBearsArray.map((bear, index) => (
          <img alt="" key={index} src={SchwierigkeitsgradFull}></img>
        ))}
      </div>
    </div>
  )

  const beschreibung = (
    <div
      className="schwierigkeitsgrad-beschreibung-title"
      dangerouslySetInnerHTML={{
        __html: props.schwierigkeit.beschreibung.childMarkdownRemark.html,
      }}
    ></div>
  )
  const trittsicherheit = (
    <div
      dangerouslySetInnerHTML={{
        __html: props.schwierigkeit.trittsicherheit.childMarkdownRemark.html,
      }}
    ></div>
  )
  const kondition = (
    <div
      dangerouslySetInnerHTML={{
        __html: props.schwierigkeit.kondition.childMarkdownRemark.html,
      }}
    ></div>
  )
  if (rest !== 0) {
    const HalfBearsHtml = <img alt="" src={SchwierigkeitsgradHalf}></img>
    return (
      <div className="schwierigkeitsgrad-container">
        <div className="schwierigkeitsgrad-beschreibung">
          <table>
            <thead>
              <tr>
                <th className="rating-th" colSpan="2">
                  <div className="schwierigkeitsgrad">
                    {fullBearsArray.map((bear, index) => (
                      <img key={index} alt="" src={SchwierigkeitsgradFull}></img>
                    ))}
                    {HalfBearsHtml}
                  </div>
                </th>
              </tr>
              <tr>
                <th colSpan="2">{beschreibung}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th>Kondition</th>
                <td>{kondition}</td>
              </tr>
              <tr className="trittsicherheit">
                <th>Trittsicherheit</th>
                <td>{trittsicherheit}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    )
  } else {
    return (
      <div className="schwierigkeitsgrad-container">
        <div className="schwierigkeitsgrad-beschreibung">
          <table>
            <thead>
              <tr>
                <th className="rating-th" colSpan="2">
                  <div className="schwierigkeitsgrad">{fullBearsHtml}</div>
                </th>
              </tr>
              <tr>
                <th colSpan="2">{beschreibung}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th>Kondition</th>
                <td>{kondition}</td>
              </tr>
              <tr className="trittsicherheit">
                <th>Trittsicherheit</th>
                <td>{trittsicherheit}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    )
  }
}
export default Schwierigkeitsgrad
